/**
 * 枚举
 */
import i18n from "@/lobby_common/locale/index";
// import Vue from "vue";

// console.log("111111", i18n, Vue.$t);

// key 需要过滤的字段， 可以传多个
const enumToList = (obj, key = "") => {
  const keys = Object.keys(obj);
  const arr = keys.map((i) => {
    const val = !isNaN(i) ? Number(i) : i;
    return {
      label: obj[i],
      value: val,
    };
  });
  if (key) {
    return arr.filter((i) => !key.includes(i.value));
  }
  return arr;
};

// 状态
export const WithdrawStatusEnum = {
  WITHDRAW_STATUS_UNKNOWN: "", // 0 全部
  WITHDRAW_STATUS_WAIT: "Datalang.Withdrawl_TIP_inreview", // 1; 待处理
  WITHDRAW_STATUS_PREPARE_PAY: "Datalang.Withdrawl_TIP_inreview", // 2; 预备支付
  WITHDRAW_STATUS_WAIT_PAY: "Datalang.Withdrawl_TIP_inreview", // 3; 待付款
  WITHDRAW_STATUS_REFUSE_WITHDRAW: "Datalang.Withdrawl_TIP_refusewithdrawal", // 4; 拒绝出款
  WITHDRAW_STATUS_CANCEL_WITHDRAW: "Datalang.Withdrawl_TIP_cancelwithdrawal", // 5; 取消出款
  WITHDRAW_STATUS_PAY_FAIL: "Datalang.Withdrawl_TIP_withdrawalfailed", // 6; 付款失败
  WITHDRAW_STATUS_PAY_SUCCESS: "Datalang.Withdrawl_TIP_withdrawlsuccessful", // 7; 已付款
  WITHDRAW_STATUS_TIMEOUT: "Datalang.Withdrawl_TIP_withdrawalfailed", // 8; 超时
};
export const WithdrawStatusList = enumToList(
  WithdrawStatusEnum,
  "WITHDRAW_STATUS_UNKNOWN"
);

// 钱包记录交易类型
export const WalletRecordRowType = [
  {
    value: "WALLET_ROW_TYPE_GAME",
    label: "Datalang.Betrecord_TITLE_game", // 游戏
  },
  {
    value: "WALLET_ROW_TYPE_INCOME",
    label: "Datalang.MemberIncomingO", // 入款
  },
  {
    value: "WALLET_ROW_TYPE_ACTIVITY",
    label: "Datalang.LowH5_BTM_eventshortja", // 活动
  },
  { value: "WALLET_ROW_TYPE_ADMIN", label: "Datalang.Home_artificial" }, // 人工
  {
    value: "WALLET_ROW_TYPE_TASK",
    label: "Datalang.Invite_TITLE_task", // 任务
  },
  {
    value: "WALLET_ROW_TYPE_FUNCTION",
    label: "Datalang.Home_Function", // 功能
  },
  {
    value: "WALLET_ROW_TYPE_PAYOUT",
    label: "Datalang.Home_tatal_outgoing", // 出款
  },
  {
    value: "WALLET_ROW_TYPE_GUESS",
    label: "Datalang.olympic_guess", // 竞猜
  },
  {
    value: "WALLET_ROW_TYPE_GIFT",
    label: "Datalang.home_Gift", // 赠礼
  },
  {
    value: "WALLET_ROW_TYPE_SILVER",
    label: "Datalang.merchant_add_down", // 银商上下分
  },
  {
    value: "WALLET_ROW_TYPE_FORGO",
    label: "Datalang.newly_give_up", // 放弃彩金
  },
  // { value: "WALLET_ROW_TYPE_TRANS", label: i18n.t("Datalang.Settlement") },
];
// 钱包记录交易子类型
export const WalletRecordSrvType = {
  // WALLET_ROW_TYPE_GAME 游戏
  WALLET_ROW_TYPE_GAME: [
    {
      value: "WALLET_SRV_TYPE_GAME_SETTLE",
      label: "Datalang.Settlement", // 结算
    },
    {
      value: "WALLET_SRV_TYPE_GAME_ACTIVITY_BONUS",
      label: "Datalang.Home_Activity_Reward", // 活动奖励
    },
    {
      value: "WALLET_SRV_TYPE_GAME_JP_BONUS",
      label: "Datalang.Home_JP_Rewards", // jp奖励
    },
    {
      value: "WALLET_SRV_TYPE_GAME_FUNCTION_BONUS",
      label: "Datalang.Home_Function_Bonus", // 功能奖励
    },
    {
      value: "WALLET_SRV_TYPE_GAME_CREATE_ROOM_BONUS",
      label: "Datalang.Home_Room_Bonus", // 创房收益
    },
    {
      value: "WALLET_SRV_TYPE_GAME_BET",
      label: "Datalang.VIP_TIP_betting", // 投注
    },
    {
      value: "WALLET_SRV_TYPE_GAME_FEE",
      label: "Datalang.Home_Tips_Tips", // 小费
    },
    {
      value: "WALLET_SRV_TYPE_GAME_CREATE_ROOM_PAYOUT",
      label: "Datalang.Home_Room_Consumption", // 创房消耗
    },
    {
      value: "WALLET_SRV_TYPE_GAME_BET_CANCEL",
      label: "Datalang.newly_bets_cancel", // 投注取消
    },
    {
      value: "WALLET_SRV_TYPE_GAME_CREATE_ROOM_REFUND",
      label: "Datalang.newly_Room_refund", // 创房退款
    },
  ],
  // WALLET_ROW_TYPE_INCOME 入款
  WALLET_ROW_TYPE_INCOME: [
    {
      value: "WALLET_SRV_TYPE_INCOME_USER_RECHARGE",
      label: "Datalang.Home_Incoming_Recharge", // 会员充值
    },
    {
      value: "WALLET_SRV_TYPE_INCOME_ADMIN_OP",
      label: "Datalang.Manualreplenishm", // 人工补单
    },
    // {
    //   value: "WALLET_SRV_TYPE_INCOME_USER_RECHARGE_REWARD",
    //   label: "Datalang.home_Single_promotion", // 单笔推广入款返利
    // },
  ],
  // WALLET_ROW_TYPE_PAYOUT 出款
  WALLET_ROW_TYPE_PAYOUT: [
    {
      value: "WALLET_SRV_TYPE_PAYOUT_USER_WITHDRAW_SUCCESS",
      label: "Datalang.Home_Successful_withdrawals", // 提现成功扣款
    },
    {
      value: "WALLET_SRV_TYPE_PAYOUT_USER_WITHDRAW_REFUSE",
      label: "Datalang.Home_Withdrawal_Rejection", // 提现失败退款
    },
    {
      value: "WALLET_SRV_TYPE_PAYOUT_USER_WITHDRAW_FREE_FROZEN",
      label: "Datalang.home_success_bet", // 免打码提现成功扣款
    },
  ],
  // WALLET_ROW_TYPE_ACTIVITY 活动
  WALLET_ROW_TYPE_ACTIVITY: [
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_PROMOTION",
      label: "Datalang.newly_promote_rewards", // 推广活动
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_REGISTER",
      label: "Datalang.Home_Registration_Bonus", // 注册送金
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_RECHARGE_FIRST",
      label: "Datalang.Home_First_Bonus", // 首充送金
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_RECHARGE_AGAIN",
      label: "Datalang.Home_Refill_Bonus", // 复充送金
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_FIRST_RECHARGE_PACKAGE",
      label: "Datalang.Event_TITLE_fristrecharge", // 首充礼包
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_RECHARGE_AGAIN_PACKAGE",
      label: "Datalang.Home_Repeat_Bonus", // 复充礼包
    },

    {
      value: "WALLET_SRV_TYPE_ACTIVITY_PRECIOUS",
      label: "Datalang.TreasureChestEv", // 宝箱活动
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_REDEEM_CODE",
      label: "Datalang.Home_Redemption_Bonus", // 兑换码红包
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_TIMING_RED_ENVELOPE",
      label: "Datalang.Scheduled_Red_Packets", // 定时红包
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_TURNTABLE",
      label: "Datalang.newly_carousel_activity", // 转盘活动
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_REBATE",
      label: "Datalang.RebateCampaign", // 返利活动
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_GRAND_PRECIOUS",
      label: "Datalang.newly_Cumulative_Activity", // 累计宝箱活动
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_NEW_USER_HELP",
      label: "Datalang.newly_New_boosting", // 拉新助力活动
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_RANK",
      label: "Datalang.Invite_BTM_rankings", // 排行榜
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_TEAM_BET_RANK",
      label: "Datalang.home_Team_leaderboard", // 团队排行榜
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_INTEREST_TREASURE",
      label: "Datalang.home_interest", // 利息宝
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_INTEREST_SIGN",
      label: "Datalang.Signin_signin", // 签到
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_GRAND_SIGN",
      label: "Datalang.Signin_TITLE_accumulatedsignin", // 累计签到
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_RECHARGE_REWARD",
      label: "Datalang.home_Single_promotion", // 单笔推广入款返利
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_COLLECT_CARD",
      label: "Datalang.home_Card_collecting", // 集卡活动
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_MYSTERIOUS_REWARDS",
      label: "Datalang.home_Secret_Reward", // 神秘奖励
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_WEEK_MONTH_CARD",
      label: "Datalang.newly_Card", // 周月卡活动
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_MULTI_RUSH_RANK",
      label: "Datalang.home_Ranking_rush", // 冲榜活动
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_EXPERIENCE",
      label: "Datalang.home_exprience", // 体验金
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_TIMELIMITED_DISCOUNT",
      label: "Datalang.home_limited_offer", // 限时奖励
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_VIP_TURNTABLE",
      label: "Datalang.newly_VIP_Wheel", // VIP转盘
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_VIP_TURNTABLE_COLLECT_CARD",
      label: "Datalang.newly_VIP_card", // VIP转盘集卡
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_DOWNLOAD",
      label: "Datalang.home_download_reward", // 下载奖励
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_RECHARGE_TURNTABLE",
      label: "Datalang.newly_spin_top", // 转盘充值
    },
    {
      value: "WALLET_SRV_TYPE_ACTIVITY_RECHARGE_UNLOCK_FREE_WITHDRAW",
      label: "Datalang.home_unlock_free", // 充值解锁免费提现
    },
  ],
  WALLET_ROW_TYPE_ADMIN: [
    {
      value: "WALLET_SRV_TYPE_ADMIN_ADD_RECHARGE_WALLET",
      label: "Datalang.Home_Manually_recharge", // 人工充值
    },
    {
      value: "WALLET_SRV_TYPE_ADMIN_ADD_WITHDRAW_WALLET",
      label: "Datalang.Home_Refund_Refund", // 人工加可提
    },
    {
      value: "WALLET_SRV_TYPE_ADMIN_ADD_BONUS_WALLET",
      label: "Datalang.Home_Manually_jackpots", // 人工加彩金
    },
    {
      value: "WALLET_SRV_TYPE_ADMIN_ADD_COMMISSION_WALLET",
      label: "Datalang.Home_Artificial_Commission", // 人工加佣金
    },

    {
      value: "WALLET_SRV_TYPE_ADMIN_REDUCE_RECHARGE_WALLET",
      label: "Datalang.newly_Manual_deduction", // 人工减充值
    },
    {
      value: "WALLET_SRV_TYPE_ADMIN_REDUCE_WITHDRAW_WALLET",
      label: "Datalang.newly_Manual_refund", // 人工减退款
    },
    {
      value: "WALLET_SRV_TYPE_ADMIN_REDUCE_BONUS_WALLET",
      label: "Datalang.newly_manual_bonus", // 人工减彩金
    },
    {
      value: "WALLET_SRV_TYPE_ADMIN_REDUCE_COMMISSION_WALLET",
      label: "Datalang.newly_Manual_commission", // 人工减佣金
    },
    {
      value: "WALLET_SRV_TYPE_ADMIN_REDUCE_EXPERIENCE_WALLET",
      label: "Datalang.home_manual_reduce", // 人工减体验金
    },
    {
      value: "WALLET_SRV_TYPE_ADMIN_ADD_EXPERIENCE_WALLET",
      label: "Datalang.home_manual_add", // 人工加体验金
    },
  ],
  // WALLET_ROW_TYPE_TASK 任务
  WALLET_ROW_TYPE_TASK: [
    {
      value: "WALLET_SRV_TYPE_TASK",
      label: "Datalang.newly_task_rewards", // 任务奖励
    },
  ],
  // WALLET_ROW_TYPE_TRANSFER  转账
  WALLET_ROW_TYPE_TRANSFER: [
    {
      value: "WALLET_SRV_TYPE_TRANSFER_COMMISSION_TO_RECHARGE",
      label: "Datalang.Commission_to", // 佣金转充值
    },
    {
      value: "WALLET_SRV_TYPE_TRANSFER_RECHARGE_TO_AVAILABLE",
      label: "Datalang.newly_re-charge_with", // 充值转可提
    },
    {
      value: "WALLET_SRV_TYPE_TRANSFER_BONUS_TO_AVAILABLE",
      label: "Datalang.newly_bonus_with", // 彩金转可提
    },
    {
      value: "WALLET_SRV_TYPE_TRANSFER_AVAILABLE_TO_RECHARGE",
      label: "Datalang.newly_Withdrawable_charge", // 可提转充值
    },
  ],
  // WALLET_ROW_TYPE_FUNCTION  功能
  WALLET_ROW_TYPE_FUNCTION: [
    {
      value: "WALLET_SRV_TYPE_FUNCTION_UPGRADE",
      label: "Datalang.Home_promotion_reward", // 升级奖励
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_VIP_WEEK",
      label: "Datalang.newly_weekly_reward", // vip周奖励
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_VIP_MONTH",
      label: "Datalang.newly_monthly_reward", // vip月奖励
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_BANKRUPTCY_RECHARGE_REWARD",
      label: "Datalang.newly_toplucky", // 幸运补贴充值赠送
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_BANKRUPTCY_SHARE_REWARD",
      label: "Datalang.newly_sharelucky", // 幸运补贴分享赠送
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_EXPERIENCE_TO_RECHARGE",
      label: "Datalang.home_deposit_color", // 体验彩金转充值
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_EXPERIENCE_DECAY",
      label: "Datalang.newly_Experience_decay", // 体验彩金衰减
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_MEDAL_EXCHANGE",
      label: "Datalang.newly_Medal_Redemption", // 勋章兑换
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_RECHARGE_GIFT",
      label: "Datalang.home_deposit_pack", // 充值礼包
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_RECHARGE_GIFT_DEDUCT",
      label: "Datalang.home_deposit_pack_deduct", // 充值礼包扣除
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_MAIL_REWARD", // 邮件奖励
      label: "Datalang.sysem_mail_reward",
    },
    {
      value: "WALLET_SRV_TYPE_FUNCTION_BANKRUPTCY_RECHARGE_GIFT_REBATE", // 破产礼包充值返利
      label: "Datalang.home_bank_cashback",
    },
  ],
  WALLET_ROW_TYPE_GUESS: [
    {
      value: "WALLET_SRV_TYPE_GUESS_OLYMPIC_BET",
      label: "Datalang.olympic_Betting", // 奥运竞猜投注
    },
  ],
  // WALLET_ROW_TYPE_GIFT  赠礼
  WALLET_ROW_TYPE_GIFT: [
    {
      value: "WALLET_ROW_TYPE_GIFT_SENDER",
      label: "Datalang.home_Handsel", // 送礼
    },
    {
      value: "WALLET_ROW_TYPE_GIFT_RECEIVER",
      label: "Datalang.home_Receive_gift", // 收礼
    },
  ],
  // WALLET_ROW_TYPE_SILVER  银商上下分
  WALLET_ROW_TYPE_SILVER: [
    {
      value: "WALLET_SRV_TYPE_SILVER_UP",
      label: "Datalang.home_Upgrade", // 上分
    },
    {
      value: "WALLET_SRV_TYPE_SILVER_DOWN",
      label: "Datalang.home_Deducted", // 下分
    },
  ],
  // WALLET_ROW_TYPE_FORGO  放弃彩金
  WALLET_ROW_TYPE_FORGO: [
    {
      value: "WALLET_SRV_TYPE_FORGO_USER_CLEAR_BONUS",
      label: "Datalang.newly_clear_bonus", // 提现成功清空彩金
    },
  ],
};

// 三方渠道 code
export const AdsCodes = [
  { label: "Appsflyer", value: "ADS_CODE_AF" }, // 1
  { label: "ADjust", value: "ADS_CODE_ADJUST" }, // 2
  { label: "Tiktok", value: "ADS_CODE_TIKTOK" }, // 3
  { label: "kwai", value: "ADS_CODE_KWAI" }, // 4
  { label: "Facebook", value: "ADS_CODE_FACEBOOK" }, // 5
  { label: "FacebookConversion", value: "ADS_CODE_FACEBOOK_CONVERSION" }, // 7
  { label: "Firebase", value: "ADS_CODE_FIREBASE" }, // 8
  { label: "Afpba", value: "ADS_CODE_AFPBA" }, // 9
  { label: "Reyun", value: "ADS_CODE_REYUN" }, // 10
];

export const promoteTimeTypeEnum = {
  PromoteTimeSearchToday: "Datalang.today_Today",
  PromoteTimeSearchYesterday: "Datalang.Threelevelagent_30",
  PromoteTimeSearchWeek: "Datalang.this_week",
  PromoteTimeSearchLastWeek: "Datalang.newly_Last_week",
  PromoteTimeSearchMonth: "Datalang.newly_this",
  PromoteTimeSearchLastMonth: "Datalang.newly_Last_month",
  // PromoteTimeSearchAll: "Datalang.HomePage_TYPE_all",
  // PromoteTimeSearchDefault: "Datalang.newly_personalization",
};
// 查询时间快捷方式列表
export const promoteTimeTypeList = enumToList(promoteTimeTypeEnum);
// 领取奖励状态
export const rewardSendStatusEnum = {
  REWARD_SEND_STATUS_UNKNOWN: "Datalang.newly_unknow",
  REWARD_SEND_STATUS_SUCCESS: "Datalang.Signin_TITLE_distributedstatus",
  REWARD_SEND_STATUS_NOT_SEND: "Datalang.Signin_TITLE_distributedtobe",
  REWARD_SEND_STATUS_SENDING: "Datalang.newly_distributing",
  REWARD_SEND_STATUS_CANCELED: "Datalang.Recharge_TITLE_cancelled",
  REWARD_SEND_STATUS_FAILED: "Datalang.Personal_TITLE_failed",
};

// 奥运类型
export const GuessTypeMap = {
  GUESS_TYPE_DEFAULT: "",
  // 奥林匹克奖牌最多
  GUESS_TYPE_OLYMPIC_MEDAL_MAX: i18n.t("Datalang.who_has_the_most_gold_medals"),
  // 奥林匹克金牌最多
  GUESS_TYPE_OLYMPIC_GOLD_MAX: i18n.t("Datalang.Gold_medal"),
  // 奥林匹克银牌最多
  GUESS_TYPE_OLYMPIC_SILVER_MAX: i18n.t("Datalang.Silver_medal"),
  // 奥林匹克铜牌最多
  GUESS_TYPE_OLYMPIC_BRONZE_MAX: i18n.t("Datalang.Bronze_medal"),
};

export const guessCountryEnum = {
  US: i18n.t("Datalang.USA"),
  CN: i18n.t("Datalang.china"),
  JP: i18n.t("Datalang.japan"),
  GB: i18n.t("Datalang.england"),
  FR: i18n.t("Datalang.france"),
  OTHER: i18n.t("Datalang.other"),
};

// homeSearch二级页面缓存
export const cacheKeys = [
  "Board",
  "PG",
  "Slot",
  "MG",
  "Hunt",
  "PP",
  "physical",
  "JILI",
  "CQ9",
  "JDB",
  "WLG",
  "PT",
  "LuckyGame",
  "Metasport",
  "Lottery",
  "Pachinko",
  "hotgame",
  "Popular",
  "smallgame",
  "WLG_cg",
  "Slot_cg",
  "hot",
  "BB",
  "spare1",
  "spare2",
  "spare3",
  "spare4",
  "spare5",
  "spare6",
  "spare7",
  "spare8",
  "spare9",
  "spare10",
  "spare111",
  "pg_slot",
  "mg_slot",
  "wlg_slot",
  "jili_slot",
  "cq9_slot",
  "jdb_slot",
  "default_popular",
];

// 三方类型code对应枚举
export const thirdCode = {
  telegram: "THIRD_LOGIN_TYPE_TELEGRAM",
  line: "THIRD_LOGIN_TYPE_LINE",
  google: "THIRD_LOGIN_TYPE_Google",
  wallet_connect: "THIRD_LOGIN_TYPE_WALLET_CONNECT",
  facebook: "THIRD_LOGIN_TYPE_FACEBOOK",
  metamask: "THIRD_LOGIN_TYPE_METAMASK",
  metamask_app: "THIRD_LOGIN_TYPE_METAMASK_APP",
  particle_network: "THIRD_LOGIN_TYPE_PARTICLE_NETWORK",
  quick_login: "THIRD_LOGIN_TYPE_QUICK_LOGIN",
  apple: "THIRD_LOGIN_TYPE_APPLE ",
  twitter: "THIRD_LOGIN_TYPE_TWITTER",
  linkedin: "THIRD_LOGIN_TYPE_LINKEDIN",
};

export const SettleTypeEnum = {
  DISTRIBUTION_SETTLE_TYPE_VALID_BET: i18n.t("Datalang.Newly_Effective_Coding"),
  DISTRIBUTION_SETTLE_TYPE_RECHARGE_AMOUNT: i18n.t(
    "Datalang.home_Deposit_amount"
  ),
  DISTRIBUTION_SETTLE_TYPE_RECHARGE_REWARD: i18n.t(
    "Datalang.home_Single_promotion"
  ),
};

// 转盘类型
export const TurntableTypeEnum = {
  TURN_TABLE_TYPE_DAY: i18n.t("Datalang.home_day"),
  TURN_TABLE_TYPE_WEEK: i18n.t("Datalang.home_week"),
  TURN_TABLE_TYPE_MONTH: i18n.t("Datalang.home_month"),
};

// 转盘类型
export const TurntableTypeEnum1 = {
  1: i18n.t("Datalang.home_day"),
  2: i18n.t("Datalang.home_week"),
  3: i18n.t("Datalang.home_month"),
};

// 转盘奖励类型
export const TurntableRewardTypeEnum = {
  TURN_TABLE_REWARD_TYPE_MONEY: i18n.t("Datalang.newly_bonus2"),
  TURN_TABLE_REWARD_TYPE_COLLECTION_CARD: i18n.t(
    "Datalang.newly_Card_Collection"
  ),
  TURN_TABLE_REWARD_TYPE_OBJECT: i18n.t("Datalang.newly_Physical_Reward"),
  TURN_TABLE_REWARD_TYPE_COLLECTION_CARD_EXCHANGE: i18n.t(
    "Datalang.newly_Card_Exchange"
  ),
};

export const RedDotTypeEnum = {
  RED_DOT_TYPE_UNKNOWN: 0,
  RED_DOT_TYPE_TURNTABLE: 1, // 转盘
  RED_DOT_TYPE_REWARD_RECORD: 2, // 奖励记录
  RED_DOT_TYPE_TASK: 3, // 任务
  RED_DOT_TYPE_INTEREST: 4, // 利息宝
  RED_DOT_TYPE_GRAND_PRECIOUS: 5, // 累计宝箱
  RED_DOT_TYPE_NEWBIE_HELP: 6, // 拉新助力
  RED_DOT_TYPE_SIGN: 7, // 签到
  RED_DOT_TYPE_TIMING_RED_PACKET: 8, // 定时红包
  RED_DOT_TYPE_PROMOTE_RECHARGE_REWARD: 9, // 推广充值返利
  RED_DOT_TYPE_MYSTERIOUS_REWARDS: 10, // 神秘奖励
  RED_DOT_TYPE_MULTI_RUSH_RANK: 11, // 开服冲榜
  RED_DOT_TYPE_COLLECT_CARD: 12, // 集卡
  RED_DOT_TYPE_PROMOTE_REWARD: 13, // 推广奖励
  RED_DOT_TYPE_VIP_TURNTABLE: 14, // VIP转盘
};

export const RedDotTypeMap = {
  JUMP_FUNCTION_TYPE_ROTARY_PLATE: "RED_DOT_TYPE_TURNTABLE", // 转盘
  JUMP_FUNCTION_TYPE_TASK_CENTER: "RED_DOT_TYPE_TASK", // 任务
  JUMP_FUNCTION_TYPE_INTEREST_TREASURE: "RED_DOT_TYPE_INTEREST", // 利息宝
  JUMP_FUNCTION_TYPE_ACCUMULATED_BOX: "RED_DOT_TYPE_GRAND_PRECIOUS", // 累计宝箱
  JUMP_FUNCTION_TYPE_NEW_USER_ASSIST: "RED_DOT_TYPE_NEWBIE_HELP", // 拉新助力
  JUMP_FUNCTION_TYPE_SIGN: "RED_DOT_TYPE_SIGN", // 签到
  JUMP_FUNCTION_TYPE_TIMED_RED_PACKET: "RED_DOT_TYPE_TIMING_RED_PACKET", // 定时红包
  // RED_DOT_TYPE_PROMOTE_RECHARGE_REWARD: 9, // 推广充值返利
  JUMP_FUNCTION_TYPE_MYSTERIOUS_REWARDS: "RED_DOT_TYPE_MYSTERIOUS_REWARDS", // 神秘奖励
  JUMP_FUNCTION_TYPE_MULTI_RUSH_RANK: "RED_DOT_TYPE_MULTI_RUSH_RANK", // 开服冲榜
  JUMP_FUNCTION_TYPE_COLLECT_CARD: "RED_DOT_TYPE_COLLECT_CARD", // 集卡
  JUMP_FUNCTION_TYPE_PROMOTION: "RED_DOT_TYPE_PROMOTE_REWARD", // 推广奖励
  JUMP_FUNCTION_TYPE_VIP_TURNTABLE: "RED_DOT_TYPE_VIP_TURNTABLE", // VIP转盘
  JUMP_FUNCTION_TYPE_WITHDRAW_RATE: "RED_DOT_TYPE_REBATE", // 返水
  JUMP_FUNCTION_TYPE_CODE_RANK: "RED_DOT_TYPE_RANK", // 打码排行榜
  JUMP_FUNCTION_TYPE_CODE_RANK_POP: "RED_DOT_TYPE_RANK", // 打码排行榜-弹窗
  JUMP_FUNCTION_TYPE_REWARD_BOX: "RED_DOT_TYPE_PRECIOUS", // 宝箱活动=宝箱奖励
  JUMP_FUNCTION_TYPE_WEEK_MONTH_CARD: "RED_DOT_TYPE_WEEK_MONTH_CARD", // 周月卡
  JUMP_FUNCTION_TYPE_CODE_RANK_POP: "RED_DOT_TYPE_TEAM_RANK", // 团队打码排行榜
};

export const RedDotTypes = Object.keys(RedDotTypeEnum);
